"use client";
import { Col, Row } from "@/utils/bootstrap";
import SvgGetApp from "./SvgGetApp";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useTranslation } from "@/hooks/localization/useTranslations";
import useIsClient from "@/hooks/useIsClient";

export function useMobileOperatingSystem() {
  const isClient = useIsClient();
  if (!isClient) return "unknown";
  if (!navigator) return "unknown";
  var userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return "iOS";
  }

  return "unknown";
}

interface Props {
  dark?: boolean;
}

const BtnGetTheApp: React.FC<Props> = ({ dark = false }) => {
  const t = useTranslation();
  const getCompany = useGetCompanyQuery();
  const company = getCompany?.data?.result;
  const getApp = company?.theme?.components?.get_app;
  const showGetApp =
    (getApp?.show_in_header && !dark) || (dark && getApp?.show_in_footer);
  const deviceType = useMobileOperatingSystem();

  if (!showGetApp) return null;
  return (
    <button
      className={`${dark ? "btn-dark" : "btn-secondary"} btn-get-the-app`}
      onClick={() =>
        (location.href =
          deviceType === "iOS" ? getApp.ios_url_app : getApp.android_url_app)
      }
    >
      <Row className="m-0 d-flex align-items-center justify-content-center">
        <Col className="col-auto p-0">
          <SvgGetApp dark={dark} />
        </Col>
        <Col className="p-0" style={{ marginInlineStart: 4 }}>
          {t?.get_the_app}
        </Col>
      </Row>
    </button>
  );
};

export default BtnGetTheApp;
